export default __webpack_public_path__ + "static/media/Trophy.ce032f4b.png";